import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useSettings, brandingUrl } from "@/context/SettingsContext";

export default function Logo({ dark = false, to = "/" }) {
  const { settings } = useSettings();
  const logo = brandingUrl(settings?.logo_file_id);
  return (
    <Link to={to} className="flex items-center gap-2.5 group" data-testid="brand-logo-link">
      {logo ? (
        <img src={logo} alt={settings.site_name} className="h-9 w-9 object-contain rounded-md" data-testid="brand-logo-image" />
      ) : (
        <span className="h-9 w-9 rounded-md bg-amber-500 text-slate-900 flex items-center justify-center transition-transform duration-300 group-hover:-rotate-6">
          <ShieldCheck className="h-5 w-5" strokeWidth={2.4} />
        </span>
      )}
      <span className="leading-none">
        <span className={`block font-display font-extrabold tracking-[0.12em] text-base ${dark ? "text-white" : "text-slate-900"}`} data-testid="brand-site-name">{settings?.site_name ?? "ADHISATYA"}</span>
        <span className={`block text-[10px] uppercase tracking-[0.25em] mt-1 ${dark ? "text-slate-400" : "text-slate-500"}`}>{settings?.tagline ?? ""}</span>
      </span>
    </Link>
  );
}
